// @flow

import {Environment} from 'relay-runtime'
import {commitMutation, graphql} from 'react-relay'

const addMutation = graphql`
    mutation StreamAddMutation(
    $input: StreamAddInput!
    ) {
        StreamAdd(input: $input) {
            streamEdge {
                node {
                    id
                }
            }
        }
    }
`;

export function commit(environment: Environment, params: any, callback: (error: ?Error, location: ?string) => void) {
    console.log("will mutate");
    
    commitMutation(
        environment,
        {
            mutation: addMutation,
            variables: {
                input: params
            },
            onCompleted: (response) => {
                
                if (response.error !== null && response.error !== undefined) {
                    callback(response.error, null);
                    return
                }
                
                callback(null, response.StreamAdd.streamEdge.node.id)
            },
            onError: (error) => {
                console.log("error mutating");
                console.log(error);
                callback(error, null);
            },
        })
}


// WEBPACK FOOTER //
// src/mutations/StreamAddMutation.js